import {Helmet} from 'react-helmet-async';
import {Heading1} from '../../components/Heading/Heading';
import styled from 'styled-components';
import {Container} from '../../components/Utils/Utils';
import {Paragraphs} from '../../components/Paragraphs/Paragraphs';

const StyledBasicSubWebPage = styled.div`
    margin-top: 50px;
    margin-bottom: 125px;

    @media screen and (max-width: 1024px) {
        margin-top: 20px;
    }
`;

const BasicSubWebPage = ({data}) => {
    return (
        <>
            <Helmet>
                <title>SSR Leiden &mdash; {data.title}</title>
            </Helmet>

            <StyledBasicSubWebPage>
                <Container>
                    <Heading1 $center>{data.title}</Heading1>
                </Container>

                <Paragraphs data={data.paragraphs} />
            </StyledBasicSubWebPage>
        </>
    );
}

export default BasicSubWebPage;